import { ErrorTipProps } from "./types/errorTipProps";
import './errorTip.scss'
import { AdditionalIcon } from "../additionalIcon/additionalIcon";
import { stylizationSmallAdditionalIcon } from "../stylization";

const ErrorTip = (props: ErrorTipProps) => {
    return (<div {...props.props}><span className={props.tipType ? props.tipType : "warningTip"}>{AdditionalIcon(props.additionalIcon, stylizationSmallAdditionalIcon)}{props.tipText}</span></div>)
}

export default ErrorTip;